import axios from "axios";

// BaseApi — 현재 사용중인 공통 API.
//  v4 / gltf-json 시대 모델 메타·로딩 + 프로필 mock 은 LegacyApi.js 로 분리 보관됨.

// v5 glb(자기완결 바이너리) 로딩용 — AppModelFacade.fetchModel 에서 사용.
export const fetchModelArrayBuffer = async (url) => {
  const { data } = await axios.get(url, {
    responseType: "arraybuffer",
    onDownloadProgress: () => {},
  });
  return data;
};

export const fetchModelDefaultKeyMap = async (modelId = "") => {
  if (modelId.includes("robot")) {
    return {
      "camera--restore": "ctrl+1",
      "animation--jump": "ctrl+2",
    };
  } else {
    return {
      "camera--restore": "ctrl+1",
      //
      "animation--agree": "ctrl+2",
      "animation--angry": "ctrl+3",
      "animation--deahat": "ctrl+4",
      "animation--die": "ctrl+5",
      "animation--embarrassment": "ctrl+6",
      "animation--happy": "ctrl+7",
      "animation--hi": "ctrl+8",
      "animation--thankyou": "ctrl+9",
      "animation--root|740428|baselayer": "shift+4",
    };
  }
};

export default {
  fetchModelArrayBuffer,
  fetchModelDefaultKeyMap,
};
